var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 784.786,
    height: 702.508,
    viewBox: "0 0 784.786 702.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.935,
    y1: 0.363,
    x2: -0.032,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#916eb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.389,
    y1: 0.968,
    x2: 0.753,
    y2: -0.026,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91298c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#481047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.013,
    y1: -0.351,
    x2: 0.798,
    y2: 1.181,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.084,
    y1: 0.01,
    x2: 1.147,
    y2: 1.256,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91298c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91298c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22426",
    "data-name": "Group 22426",
    transform: "translate(-609.221 -230.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background_lines",
    "data-name": "background lines",
    transform: "translate(-428 -643)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "horizontal_lines",
    "data-name": "horizontal lines",
    transform: "translate(1070.5 967.225)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 700.478,
    transform: "translate(0 309.034)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 700.478,
    transform: "translate(0 412.046)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 700.478,
    transform: "translate(0 515.057)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 700.478,
    transform: "translate(0 206.023)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 700.478,
    transform: "translate(1.03 103.011)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 700.478,
    transform: "translate(1.03)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "horizontal_lines-2",
    "data-name": "horizontal lines",
    transform: "translate(1678.782 874) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1-2",
    "data-name": "Line 1",
    x2: 700.478,
    transform: "translate(0 309.034)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2-2",
    "data-name": "Line 2",
    x2: 700.478,
    transform: "translate(0 412.046)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3-2",
    "data-name": "Line 3",
    x2: 700.478,
    transform: "translate(0 515.057)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4-2",
    "data-name": "Line 4",
    x2: 700.478,
    transform: "translate(0 206.023)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5-2",
    "data-name": "Line 5",
    x2: 700.478,
    transform: "translate(1.03 103.011)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6-2",
    "data-name": "Line 6",
    x2: 700.478,
    transform: "translate(1.03 0)",
    fill: "none",
    stroke: "rgba(248,225,247,0.5)",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "10 10"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    transform: "translate(-185.104 162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round_neon_lines",
    "data-name": "round neon lines",
    transform: "translate(1055.031 222.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4149",
    "data-name": "Group 4149",
    transform: "translate(32.298 32.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_638",
    "data-name": "Ellipse 638",
    transform: "translate(-0.225 -0.226)",
    fill: "none",
    stroke: "#cb86dd",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.5,
    cy: 127,
    rx: 127.5,
    ry: 127,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.5,
    cy: 127,
    rx: 124,
    ry: 123.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_637",
    "data-name": "Ellipse 637",
    transform: "translate(-0.225 1.774)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.5,
    cy: 126,
    rx: 127.5,
    ry: 126,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.5,
    cy: 126,
    rx: 126.5,
    ry: 125,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4148",
    "data-name": "Group 4148",
    transform: "translate(0.072 0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_638-2",
    "data-name": "Ellipse 638",
    transform: "translate(0.001 0)",
    fill: "none",
    stroke: "#cb86dd",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.5,
    cy: 160,
    rx: 160.5,
    ry: 160,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.5,
    cy: 160,
    rx: 157,
    ry: 156.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_637-2",
    "data-name": "Ellipse 637",
    transform: "translate(0.001 2)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.5,
    cy: 160,
    rx: 160.5,
    ry: 160,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.5,
    cy: 160,
    rx: 159.5,
    ry: 159,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404,
    transform: "translate(794.325 308.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4117",
    "data-name": "Group 4117",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4109",
    "data-name": "Group 4109",
    transform: "translate(185.822 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4107",
    "data-name": "Group 4107",
    transform: "translate(11.998 0.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11973",
    "data-name": "Path 11973",
    d: "M599.214,407.372h-5.659a7,7,0,0,0-6.968,6.968v11.317a7,7,0,0,1-6.969,6.968H545.406a7,7,0,0,1-6.968-6.968V414.341a7,7,0,0,0-6.968-6.968h-62.4A7,7,0,0,1,462.1,400.4V377.98A6.9,6.9,0,0,1,463.357,374l59.152-85.611a6.961,6.961,0,0,1,5.711-2.987h34.213a6.981,6.981,0,0,1,5.816,10.845L527.121,358.07a6.977,6.977,0,1,0,12.784,3.877v-8.54a7,7,0,0,1,6.968-6.968h32.746a7,7,0,0,1,6.969,6.968v8.54a7,7,0,0,0,6.968,6.968h5.606a7,7,0,0,1,6.968,6.968V400.4A6.921,6.921,0,0,1,599.214,407.372Z",
    transform: "translate(-462.1 -281.942)",
    fill: "#e4eff7",
    stroke: "#91298c",
    strokeWidth: 3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11974",
    "data-name": "Path 11974",
    d: "M782.317,423.668q-15.011-9.117-23.577-26.511c-5.659-11.579-8.54-25.358-8.54-41.339s2.829-29.76,8.54-41.338c5.658-11.579,13.517-20.381,23.577-26.511,10.007-6.078,21.534-9.169,34.58-9.169s24.573,3.039,34.58,9.169q15.011,9.116,23.577,26.511c5.658,11.579,8.54,25.358,8.54,41.338s-2.83,29.76-8.54,41.339c-5.659,11.579-13.518,20.381-23.577,26.511-10.007,6.078-21.534,9.169-34.58,9.169s-24.573-3.039-34.58-9.169Zm51.4-67.8h0c0-24.835-5.606-37.2-16.818-37.2s-16.818,12.417-16.818,37.2,5.606,37.2,16.818,37.2S833.715,380.653,833.715,355.871Z",
    transform: "translate(-599.254 -278.8)",
    fill: "#e4eff7",
    stroke: "#91298c",
    strokeWidth: 3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11975",
    "data-name": "Path 11975",
    d: "M1162.661,407.372h-5.606a7,7,0,0,0-6.969,6.968v11.317a7,7,0,0,1-6.969,6.968h-34.213a7,7,0,0,1-6.969-6.968V414.341a7,7,0,0,0-6.968-6.968h-62.4a7,7,0,0,1-6.968-6.968V377.98a6.9,6.9,0,0,1,1.257-3.982l59.152-85.611a6.962,6.962,0,0,1,5.711-2.987h34.213a6.981,6.981,0,0,1,5.816,10.845L1090.62,358.07a6.977,6.977,0,1,0,12.784,3.877v-8.54a7,7,0,0,1,6.969-6.968h32.746a7,7,0,0,1,6.969,6.968v8.54a7,7,0,0,0,6.969,6.968h5.606a7,7,0,0,1,6.969,6.968V400.4A6.932,6.932,0,0,1,1162.661,407.372Z",
    transform: "translate(-730.361 -281.942)",
    fill: "#e4eff7",
    stroke: "#91298c",
    strokeWidth: 3,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4108",
    "data-name": "Group 4108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11976",
    "data-name": "Path 11976",
    d: "M576.262,405.972h-5.606a7,7,0,0,0-6.968,6.968v11.317a7,7,0,0,1-6.968,6.968H522.506a7,7,0,0,1-6.968-6.968V412.941a7,7,0,0,0-6.969-6.968h-62.4A7,7,0,0,1,439.2,399V376.58a6.9,6.9,0,0,1,1.258-3.982l59.152-85.611A6.962,6.962,0,0,1,505.321,284h34.213a6.981,6.981,0,0,1,5.816,10.845L504.22,356.67A6.977,6.977,0,1,0,517,360.547v-8.54a7,7,0,0,1,6.968-6.968h32.746a7,7,0,0,1,6.968,6.968v8.488a7,7,0,0,0,6.968,6.968h5.606a7,7,0,0,1,6.968,6.968v24.52A6.977,6.977,0,0,1,576.262,405.972Z",
    transform: "translate(-439.2 -280.542)",
    fill: "#fff",
    stroke: "#91298c",
    strokeWidth: 3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11977",
    "data-name": "Path 11977",
    d: "M759.417,422.268q-15.011-9.116-23.577-26.511c-5.659-11.579-8.54-25.358-8.54-41.339s2.829-29.76,8.54-41.339c5.659-11.579,13.517-20.381,23.577-26.511,10.007-6.078,21.534-9.169,34.58-9.169s24.573,3.039,34.58,9.169q15.011,9.117,23.577,26.511c5.658,11.579,8.54,25.358,8.54,41.339s-2.829,29.76-8.54,41.339c-5.658,11.579-13.518,20.381-23.577,26.511-10.007,6.078-21.534,9.169-34.58,9.169q-19.569-.078-34.58-9.169Zm51.4-67.8h0c0-24.835-5.606-37.2-16.818-37.2s-16.818,12.417-16.818,37.2,5.606,37.2,16.818,37.2S810.815,379.253,810.815,354.471Z",
    transform: "translate(-576.354 -277.4)",
    fill: "#fff",
    stroke: "#91298c",
    strokeWidth: 3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11978",
    "data-name": "Path 11978",
    d: "M1139.762,405.972h-5.606a7,7,0,0,0-6.968,6.968v11.317a7,7,0,0,1-6.968,6.968h-34.213a7,7,0,0,1-6.969-6.968V412.941a7,7,0,0,0-6.968-6.968h-62.4A7,7,0,0,1,1002.7,399V376.58a6.9,6.9,0,0,1,1.258-3.982l59.152-85.611a6.961,6.961,0,0,1,5.711-2.986h34.213a6.981,6.981,0,0,1,5.816,10.845L1067.72,356.67a6.977,6.977,0,1,0,12.784,3.877v-8.54a7,7,0,0,1,6.968-6.968h32.746a7,7,0,0,1,6.968,6.968v8.488a7,7,0,0,0,6.969,6.968h5.606a7,7,0,0,1,6.968,6.968v24.52A6.976,6.976,0,0,1,1139.762,405.972Z",
    transform: "translate(-707.461 -280.542)",
    fill: "#fff",
    stroke: "#91298c",
    strokeWidth: 3,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4116",
    "data-name": "Group 4116",
    transform: "translate(0 107.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4111",
    "data-name": "Group 4111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4110",
    "data-name": "Group 4110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11979",
    "data-name": "Path 11979",
    d: "M179.5,598.324c21.586,0,39.4-6.916,54.07-20.853,17.552-16.714,27.716-40.448,37.514-63.4,11.107-25.935,21.586-50.455,40.71-56.585a26.675,26.675,0,0,1,23.472,2.777c32.327,20.119,44.535,100.177,44.692,100.963l10.9-1.624c-.524-3.51-13.151-85.926-49.774-108.717-10.112-6.287-21.115-7.6-32.641-3.929-23.944,7.649-35.418,34.422-47.521,62.767-18.809,44.011-38.3,89.541-106.1,74.661L122.02,573.8a5.534,5.534,0,1,0-3.406,10.531l33.532,10.845A133.657,133.657,0,0,0,179.5,598.324Z",
    transform: "translate(-114.778 -444.932)",
    fill: "#91298c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11980",
    "data-name": "Path 11980",
    d: "M582.9,747.083l-11.736-56.952a39.24,39.24,0,0,1,76.39-17.866l14.408,55.223Z",
    transform: "translate(-331.663 -539.202)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11981",
    "data-name": "Path 11981",
    d: "M594.335,823.546c1.257,5.239,20.224,5.187,42.281-.157,22.11-5.344,38.981-13.884,37.724-19.124s-20.224-5.187-42.282.157C609.948,809.766,593.025,818.306,594.335,823.546Z",
    transform: "translate(-343.044 -614.145)",
    fill: "#efdfee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11982",
    "data-name": "Path 11982",
    d: "M685.38,813.192c-.314,1.781,2.829,3.825,7.073,4.558s7.911-.053,8.226-1.834-2.829-3.825-7.073-4.558C689.414,810.625,685.695,811.463,685.38,813.192Z",
    transform: "translate(-386.41 -619.247)",
    fill: "#481047",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11983",
    "data-name": "Path 11983",
    d: "M632.28,829.492c-.314,1.781,2.829,3.825,7.073,4.558s7.911-.052,8.226-1.834-2.829-3.825-7.073-4.558S632.595,827.763,632.28,829.492Z",
    transform: "translate(-361.132 -627.007)",
    fill: "#481047",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11984",
    "data-name": "Path 11984",
    d: "M661.9,659.3s17.028,6.182,22.477,24c5.4,17.814,10.06,40.657,10.06,40.657l-15.509.367Z",
    transform: "translate(-375.243 -546.985)",
    fill: "#bc95be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11985",
    "data-name": "Path 11985",
    d: "M625.726,620.8,617.5,635.156l10.845-2.515Z",
    transform: "translate(-354.106 -528.656)",
    fill: "#481047",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4115",
    "data-name": "Group 4115",
    transform: "translate(379.601 20.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4112",
    "data-name": "Group 4112",
    transform: "translate(102.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11986",
    "data-name": "Path 11986",
    d: "M1307.33,540.271l-4.4,9.745c-.786-.367-18.862-8.75-35.523-38.352-4.82-8.54-12.207-18.6-20.014-17.657-5.606.681-20.486,8.645-37.409,68.217-18.443,64.968-57.947,107.459-117.362,126.216-38.457,12.155-86.03-13.78-88.021-14.88l5.187-9.378c.576.314,45.635,24.782,79.638,14.041,55.747-17.6,92.894-57.633,110.289-118.933,13.937-49.04,29.131-73.875,46.473-75.918,11-1.31,21.272,6.445,30.6,23.053,14.88,26.564,30.389,33.742,30.546,33.847ZM1009.787,664.181h0l-2.568,4.663,2.568-4.663Z",
    transform: "translate(-1004.6 -483.229)",
    fill: "#91298c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4113",
    "data-name": "Group 4113",
    transform: "translate(0 141.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11987",
    "data-name": "Path 11987",
    d: "M817.408,753.373,845.6,773.807a5.25,5.25,0,1,1-6.182,8.488l-28.188-20.433a5.251,5.251,0,0,1,6.183-8.488Z",
    transform: "translate(-809.053 -752.353)",
    fill: "#592758",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4114",
    "data-name": "Group 4114",
    transform: "translate(21.743 109.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11988",
    "data-name": "Path 11988",
    d: "M858.908,693.673,887.1,714.106a5.25,5.25,0,0,1-6.182,8.488l-28.188-20.434a5.25,5.25,0,1,1,6.182-8.488Z",
    transform: "translate(-850.553 -692.653)",
    fill: "#481047",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11989",
    "data-name": "Path 11989",
    d: "M1038.8,843.225l-17.5,2.62,4.82-9.745,16.557,6.5Z",
    transform: "translate(-910.096 -651.218)",
    fill: "#481047",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11990",
    "data-name": "Path 11990",
    d: "M829.1,749.688l48.778,31.7a39.238,39.238,0,0,0,44.43-64.654L876.1,683.2Z",
    transform: "translate(-818.597 -578.428)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11991",
    "data-name": "Path 11991",
    d: "M860.3,800.694,871.512,785.5,929.093,827a35.75,35.75,0,0,1-29.707-.838C883.51,818.4,860.3,800.694,860.3,800.694Z",
    transform: "translate(-833.45 -627.129)",
    fill: "#bc95be",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7242",
    "data-name": "Path 7242",
    d: "M174.323,150.43,164.2,129.723,184.907,119.6l10.123,20.707Zm-3.911-18.406,5.982,12.424,12.424-5.982-5.982-12.424Z",
    transform: "translate(830.15 358.916)",
    fill: "#fbb516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7243",
    "data-name": "Path 7243",
    d: "M127.062,79.125a7.413,7.413,0,0,1-7.362-7.362,7.362,7.362,0,1,1,14.725,0A7.413,7.413,0,0,1,127.062,79.125Zm0-12.654a5.062,5.062,0,1,0,5.062,5.062A4.828,4.828,0,0,0,127.062,66.471Z",
    transform: "translate(887.508 215.093)",
    fill: "#f7d38b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7244",
    "data-name": "Path 7244",
    d: "M192.384,60.242a6.442,6.442,0,1,1-6.442-6.442A6.431,6.431,0,0,1,192.384,60.242Z",
    transform: "translate(1152.556 172.495)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3408",
    "data-name": "Group 3408",
    transform: "translate(907.787 195.11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 3.911,
    height: 11.734,
    transform: "matrix(0.248, 0.969, -0.969, 0.248, 28.568, 0)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 4.141,
    height: 11.734,
    transform: "translate(22.916 5.644) rotate(75.623)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 3.911,
    height: 11.734,
    transform: "translate(17.033 11.337) rotate(75.623)",
    fill: "#91288c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 3.911,
    height: 11.734,
    transform: "matrix(0.248, 0.969, -0.969, 0.248, 11.366, 16.964)",
    fill: "#91288c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12021",
    "data-name": "Path 12021",
    d: "M174.323,150.43,164.2,129.723,184.907,119.6l10.123,20.707Zm-3.911-18.406,5.982,12.424,12.424-5.982-5.982-12.424Z",
    transform: "translate(1161.465 402.131)",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "paper_plan",
    "data-name": "paper plan",
    transform: "translate(1364.395 191.947) rotate(20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4093",
    "data-name": "Group 4093",
    transform: "translate(173.174 1.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M10.464,1.759,1.341,9.54,0,0Z",
    transform: "translate(19.855 43.734)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9768",
    "data-name": "Path 9768",
    d: "M.656,0,0,43.048a3.054,3.054,0,0,0,3.1,3.1L46.327,45.2a1.209,1.209,0,0,0,.8-2.087Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9769",
    "data-name": "Path 9769",
    d: "M29.663,45.493,0,0,22.687,45.672l-2.444,2.266Z",
    transform: "translate(0.657 0)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9770",
    "data-name": "Path 9770",
    d: "M0,.089,2,7.6,4.143,0Z",
    transform: "translate(19.2 45.672)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2639",
    "data-name": "Group 2639",
    transform: "translate(0 171.904) rotate(-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9721",
    "data-name": "Path 9721",
    d: "M.264,1,2.209.047a.46.46,0,0,1,.405.826H2.6L.67,1.83H.653a.461.461,0,0,1-.616-.211A.482.482,0,0,1,.264,1Z",
    transform: "translate(0 10.274)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9722",
    "data-name": "Path 9722",
    d: "M.287.861,2.3.035a.465.465,0,0,1,.6.243.465.465,0,0,1-.243.6H2.637L.644,1.7H.628a.465.465,0,0,1-.6-.243A.473.473,0,0,1,.287.861Z",
    transform: "translate(5.875 7.662)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9723",
    "data-name": "Path 9723",
    d: "M.324.721l2.058-.7A.461.461,0,1,1,2.674.9H2.658L.616,1.6H.6A.459.459,0,0,1,.017,1.3.5.5,0,0,1,.324.721Z",
    transform: "translate(11.898 5.437)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9724",
    "data-name": "Path 9724",
    d: "M.35.6,2.44.015a.467.467,0,0,1,.567.324.466.466,0,0,1-.324.567H2.667L.593,1.474H.576A.466.466,0,0,1,.009,1.15.482.482,0,0,1,.35.6Z",
    transform: "translate(18.063 3.582)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9725",
    "data-name": "Path 9725",
    d: "M.377.462,2.5.009A.475.475,0,0,1,3.05.365a.475.475,0,0,1-.357.551H2.678L.571,1.354H.555A.475.475,0,0,1,0,1,.5.5,0,0,1,.377.462Z",
    transform: "translate(24.339 2.114)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9726",
    "data-name": "Path 9726",
    d: "M.409.328,2.548,0a.472.472,0,0,1,.535.389.473.473,0,0,1-.389.535H2.677L.555,1.252H.538A.472.472,0,0,1,0,.863.484.484,0,0,1,.409.328Z",
    transform: "translate(30.707 1.033)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9727",
    "data-name": "Path 9727",
    d: "M.438.2,2.593,0a.459.459,0,0,1,.5.421.459.459,0,0,1-.421.5H2.658L.519,1.119H.5A.459.459,0,0,1,0,.7.492.492,0,0,1,.438.2Z",
    transform: "translate(37.127 0.323)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9728",
    "data-name": "Path 9728",
    d: "M.47.065,2.641,0a.481.481,0,0,1,.486.454A.481.481,0,0,1,2.674.94H2.658L.5,1H.486A.481.481,0,0,1,0,.551.508.508,0,0,1,.47.065Z",
    transform: "translate(43.577 0)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9729",
    "data-name": "Path 9729",
    d: "M.5,0,2.674.065a.461.461,0,0,1,.454.486A.461.461,0,0,1,2.642,1H2.626L.471.94H.454A.46.46,0,0,1,0,.454.508.508,0,0,1,.5,0Z",
    transform: "translate(50.041 0)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9730",
    "data-name": "Path 9730",
    d: "M.538,0,2.693.2a.472.472,0,0,1-.1.94H2.58L.441.943H.425A.472.472,0,0,1,0,.425.5.5,0,0,1,.538,0Z",
    transform: "translate(56.504 0.337)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9731",
    "data-name": "Path 9731",
    d: "M.575.008l2.139.34a.477.477,0,1,1-.162.94H2.536L.413.948H.4A.476.476,0,0,1,.008.4.5.5,0,0,1,.575.008Z",
    transform: "translate(62.932 1.078)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9732",
    "data-name": "Path 9732",
    d: "M.581.014,2.7.5a.474.474,0,1,1-.211.924H2.477L.387.938H.371A.474.474,0,0,1,.014.371.459.459,0,0,1,.581.014Z",
    transform: "translate(69.342 2.238)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9733",
    "data-name": "Path 9733",
    d: "M.623.022,2.7.67a.488.488,0,0,1,.324.6.488.488,0,0,1-.6.324H2.406L.348.962H.332a.466.466,0,0,1-.308-.6A.472.472,0,0,1,.623.022Z",
    transform: "translate(75.603 3.85)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9734",
    "data-name": "Path 9734",
    d: "M.664.032c.68.259,1.345.535,2.009.81a.483.483,0,1,1-.373.891h0C1.637,1.458.972,1.2.308.94h0A.491.491,0,0,1,.032.308.491.491,0,0,1,.664.032Z",
    transform: "translate(81.736 5.93)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9735",
    "data-name": "Path 9735",
    d: "M.7.047l1.961.94a.486.486,0,1,1-.421.875H2.218L.29.922H.274A.486.486,0,1,1,.7.047Z",
    transform: "translate(87.684 8.476)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9736",
    "data-name": "Path 9736",
    d: "M.742.062l1.88,1.069A.5.5,0,0,1,2.8,1.8a.5.5,0,0,1-.664.178H2.12L.256.9H.24A.5.5,0,0,1,.062.24.52.52,0,0,1,.742.062Z",
    transform: "translate(93.438 11.41)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9737",
    "data-name": "Path 9737",
    d: "M.78.082,2.578,1.3a.477.477,0,0,1,.13.681.477.477,0,0,1-.681.13H2.011L.229.908H.213A.491.491,0,0,1,.083.228.505.505,0,0,1,.78.082Z",
    transform: "translate(98.975 14.76)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9738",
    "data-name": "Path 9738",
    d: "M.815.1l1.7,1.345a.5.5,0,0,1-.616.778H1.885L.2.894H.183A.487.487,0,0,1,.1.214.506.506,0,0,1,.815.1Z",
    transform: "translate(104.254 18.502)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9739",
    "data-name": "Path 9739",
    d: "M.837.135l1.6,1.458a.493.493,0,0,1-.664.729H1.761L.173.88H.157a.5.5,0,0,1-.032-.7A.484.484,0,0,1,.837.135Z",
    transform: "translate(109.255 22.615)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9740",
    "data-name": "Path 9740",
    d: "M.835.158,2.342,1.73a.493.493,0,1,1-.713.68h0L.138.855h0a.489.489,0,0,1,.016-.7A.445.445,0,0,1,.835.158Z",
    transform: "translate(113.989 27.08)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9741",
    "data-name": "Path 9741",
    d: "M.861.174,2.254,1.827a.495.495,0,1,1-.762.632h0L.116.806h0A.489.489,0,1,1,.861.174Z",
    transform: "translate(118.354 31.844)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9742",
    "data-name": "Path 9742",
    d: "M.874.2l1.3,1.734a.5.5,0,0,1-.794.6h0L.1.818h0a.507.507,0,0,1,.1-.7A.451.451,0,0,1,.874.2Z",
    transform: "translate(122.44 36.888)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9743",
    "data-name": "Path 9743",
    d: "M.908.224l1.2,1.8a.5.5,0,0,1-.843.551h0L.082.775h0a.5.5,0,0,1,.146-.7A.5.5,0,0,1,.908.224Z",
    transform: "translate(126.182 42.149)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744",
    "data-name": "Path 9744",
    d: "M.931.239,2.05,2.1a.509.509,0,0,1-.875.519h0L.073.774h0a.505.505,0,0,1,.178-.7A.485.485,0,0,1,.931.239Z",
    transform: "translate(129.675 47.61)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9745",
    "data-name": "Path 9745",
    d: "M.936.268l1.037,1.9a.494.494,0,0,1-.211.681.494.494,0,0,1-.681-.211h0L.061.738h0A.494.494,0,0,1,.272.058.5.5,0,0,1,.936.268Z",
    transform: "translate(132.927 53.204)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9746",
    "data-name": "Path 9746",
    d: "M.962.274,1.934,2.2a.507.507,0,0,1-.907.454h0L.054.728h0A.513.513,0,0,1,.281.047.524.524,0,0,1,.962.274Z",
    transform: "translate(135.931 58.934)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9747",
    "data-name": "Path 9747",
    d: "M.97.284l.924,1.961a.511.511,0,1,1-.924.438h0L.047.738h0A.515.515,0,0,1,.29.057.5.5,0,0,1,.97.284Z",
    transform: "translate(138.791 64.757)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748",
    "data-name": "Path 9748",
    d: "M.968.294l.891,1.977a.515.515,0,1,1-.94.421h0L.044.732h0A.517.517,0,0,1,.3.051.5.5,0,0,1,.968.294Z",
    transform: "translate(141.516 70.629)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9749",
    "data-name": "Path 9749",
    d: "M.984.3,1.842,2.28A.515.515,0,1,1,.9,2.7h0L.044.724A.515.515,0,1,1,.984.3Z",
    transform: "translate(144.125 76.55)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9750",
    "data-name": "Path 9750",
    d: "M.984.3,1.842,2.28A.515.515,0,0,1,.9,2.7h0L.044.724A.515.515,0,0,1,.984.3Z",
    transform: "translate(146.717 82.481)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9751",
    "data-name": "Path 9751",
    d: "M.984.31l.891,1.961h0a.515.515,0,1,1-.94.421h0L.044.715A.517.517,0,0,1,.3.034.539.539,0,0,1,.984.31Z",
    transform: "translate(149.326 88.405)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9752",
    "data-name": "Path 9752",
    d: "M.994.3l.94,1.944h0a.522.522,0,0,1-.94.454h0L.054.751A.522.522,0,0,1,.994.3Z",
    transform: "translate(152.022 94.283)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9753",
    "data-name": "Path 9753",
    d: "M1,.282l1.021,1.9v.016a.526.526,0,1,1-.923.5h0L.061.784A.531.531,0,0,1,.271.071.515.515,0,0,1,1,.282Z",
    transform: "translate(154.899 100.083)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9754",
    "data-name": "Path 9754",
    d: "M.976.25,2.126,2.065l.016.016a.528.528,0,0,1-.891.567h0L.084.817A.527.527,0,0,1,.246.088.514.514,0,0,1,.976.25Z",
    transform: "translate(158.117 105.705)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9755",
    "data-name": "Path 9755",
    d: "M.957.212,2.286,1.881,2.3,1.9a.53.53,0,0,1-.826.664h0L.114.86A.537.537,0,0,1,.2.114.537.537,0,0,1,.941.2Z",
    transform: "translate(161.748 111.058)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9756",
    "data-name": "Path 9756",
    d: "M.889.158c.5.5,1.037.972,1.572,1.442a.528.528,0,1,1-.7.794h0C1.213,1.908.679,1.422.16.9A.533.533,0,0,1,.144.158.518.518,0,0,1,.889.158Z",
    transform: "translate(166.029 115.925)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9757",
    "data-name": "Path 9757",
    d: "M.822.085c.6.389,1.2.745,1.815,1.086a.521.521,0,0,1,.211.713.535.535,0,0,1-.729.211h0C1.471,1.738.839,1.365.239.96A.543.543,0,0,1,.077.231.558.558,0,0,1,.822.085Z",
    transform: "translate(171.054 119.984)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9758",
    "data-name": "Path 9758",
    d: "M.711.03c.664.243,1.345.454,2.025.632a.522.522,0,0,1,.373.648.522.522,0,0,1-.648.373h0c-.713-.194-1.41-.405-2.106-.664A.536.536,0,0,1,.03.338.542.542,0,0,1,.711.03Z",
    transform: "translate(176.837 122.858)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9759",
    "data-name": "Path 9759",
    d: "M.487.376A14.988,14.988,0,0,0,2.529.02a.518.518,0,0,1,.648.389.518.518,0,0,1-.389.648h0a12.82,12.82,0,0,1-2.2.389A.541.541,0,0,1,0,.959.533.533,0,0,1,.487.376Z",
    transform: "translate(183.17 123.5)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9760",
    "data-name": "Path 9760",
    d: "M.262,1.275A17.969,17.969,0,0,0,2,.108a.558.558,0,0,1,.762.1.558.558,0,0,1-.1.762h0A15.878,15.878,0,0,1,.813,2.2.53.53,0,0,1,.084,2,.513.513,0,0,1,.262,1.275Z",
    transform: "translate(189.277 120.625)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9761",
    "data-name": "Path 9761",
    d: "M.128,1.92A18.253,18.253,0,0,0,1.391.235.543.543,0,0,1,2.137.089a.543.543,0,0,1,.146.745A20.3,20.3,0,0,1,.954,2.617a.54.54,0,0,1-.826-.7Z",
    transform: "translate(194.175 115.912)",
    fill: "url(#linear-gradient-7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.cb54a983c4a2c77a28566a755470e5ee.svg";
export { ForwardRef as ReactComponent };